// src/v3/actions/filter.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var FilterIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "FilterIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M21.6187 3.89343C21.5033 3.62672 21.312 3.39983 21.0686 3.24098C20.8253 3.08213 20.5406 2.99833 20.25 2.99999H3.74997C3.45966 3.00057 3.17575 3.08537 2.93269 3.24412C2.68962 3.40288 2.49785 3.62875 2.38063 3.89435C2.26341 4.15995 2.22579 4.45386 2.27232 4.74042C2.31886 5.02698 2.44755 5.29388 2.64279 5.50874L2.65029 5.51718L8.99997 12.2972V19.5C8.99991 19.7715 9.07353 20.0379 9.21297 20.2708C9.35241 20.5037 9.55246 20.6945 9.79178 20.8226C10.0311 20.9508 10.3007 21.0116 10.5719 20.9986C10.843 20.9856 11.1056 20.8992 11.3315 20.7487L14.3315 18.7481C14.5372 18.6111 14.7058 18.4255 14.8224 18.2076C14.939 17.9898 15 17.7465 15 17.4994V12.2972L21.3506 5.51718L21.3581 5.50874C21.5554 5.29486 21.6853 5.02761 21.7317 4.74034C21.778 4.45307 21.7387 4.15851 21.6187 3.89343ZM13.9068 11.2762C13.6463 11.5524 13.5008 11.9175 13.5 12.2972V17.4994L10.5 19.5V12.2972C10.5008 11.9161 10.3559 11.5492 10.095 11.2716L3.74997 4.49999H20.25L13.9068 11.2762Z"
  }
) });

export {
  FilterIcon
};
